import { GameRuleKey, GameRules } from "@uno/protocol";
import getPublicAssetUrl from "utils/PublicAsset";

export type HouseRule = {
    key: GameRuleKey;
    icon: string;
    name: string;
    description: string;
};

export const HOUSE_RULES: HouseRule[] = [
    {
        key: "noStacking",
        icon: getPublicAssetUrl("assets/rules/no-stacking.webp"),
        name: "rules.house.no_stacking.name",
        description: "rules.house.no_stacking.description",
    },
    {
        key: "drawUntilPlayable",
        icon: getPublicAssetUrl("assets/rules/draw-until-playable.webp"),
        name: "rules.house.draw_until_playable.name",
        description: "rules.house.draw_until_playable.description",
    },
    {
        key: "sevenZero",
        icon: getPublicAssetUrl("assets/rules/seven-zero.webp"),
        name: "rules.house.seven_zero.name",
        description: "rules.house.seven_zero.description",
    },
];

export const activeHouseRules = (rules: GameRules): HouseRule[] => {
    return HOUSE_RULES.filter((rule) => rules[rule.key]);
};
